/* eslint-disable func-names, max-len */
$('.automotive__product-content a').click(function () {
  const clickedId = $(this).attr('data-item-pos');
  const scrollTo = $(`.automotive-items .automotive-item[data-item-pos=${clickedId}]`);

  $('html, body').animate({
    scrollTop: scrollTo.position().top,
  }, 2000);
});
